import styled from "styled-components";

export const ZmianaHaslaPageStyle = styled.div`
  max-width: 1018px;
  display: grid;
  grid-template-rows: 72px 1fr;
  padding-left: 28px;
  grid-gap: 8px;

  header {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 96px;
  }

  .password {
    margin-top: 8px;
  }

  .panel {
    background-color: ${(props) => props.theme.palette.background.paper};
    padding: 24px;
    display: grid;
    border-radius: 3px;

    h6 {
      margin-bottom: 20px;
    }

    .panel__dane {
      display: grid;
      grid-template-rows: 72px 104px 72px;
      width: 400px;
    }
  }
`;
